import { useEffect } from 'react';

interface SEOSchemaProps {
  schema: object | object[];
  id?: string;
}

export default function SEOSchema({ schema, id = 'seo-schema' }: SEOSchemaProps) {
  useEffect(() => {
    const existing = document.getElementById(id);
    if (existing) {
      existing.remove();
    }
    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.id = id;
    script.textContent = JSON.stringify(schema);
    document.head.appendChild(script);
    return () => {
      const el = document.getElementById(id);
      if (el) el.remove();
    };
  }, [schema, id]);

  return null;
}
